import { useEffect, useState } from "react";
import sal from "sal.js";
import CallToAction from "../Call-To-Action/CallToAction";
import CategoryOne from "../Category/CategoryOne";
import Counter from "../Counters/Counter";
import EventCarouse from "../Events/EventCarouse";
import TeamTwo from "../Team/TeamTwo";
import TestimonialSeven from "../Testimonials/Testimonial-Seven";
import MainDemoBanner from "./MainDemoBanner";

import { ParallaxProvider } from "react-scroll-parallax";
import NewsletterTwo from "../Newsletters/Newsletter-Two";
import CourseSection from "./CourseSection";
import JobSection from "./JobSection";
import CategorySection from "./CategorySection";
import EventSection from "./EventSection";
import TrainerSection from "./TrainerSection";
import TestimonialSection from "./TestimonialSection";
import JobCarousel from "../Cards/Job-card";
import Link from "next/link";
import AboutUs from "../Abouts/AboutUs";
import { useUser } from "@/context/UserContext";
import ProfileIncompleteModal from "../ProfileIncompleteModal/Modal";
import DocumentationSection from "./DocumentationSection";

const MainDemo = () => {
  useEffect(() => {
    sal({
      threshold: 0.01,
      once: true,
    });
  }, []);

  const [showModal, setShowModal] = useState(false);
  const { user } = useUser();
  useEffect(() => {
    const justLoggedIn = localStorage.getItem("login");

    if (justLoggedIn === "true" && user?.profileComplete === false) {
      setShowModal(true);
      localStorage.setItem("login", "false");
    }
  }, [user]);

  return (
    <>
      <main className="rbt-main-wrapper">
        <div className="rbt-banner-area rbt-banner-1">
          <MainDemoBanner />
        </div>

        <div className="rbt-categories-area bg-color-white rbt-section-gapBottom">
          <CategorySection />
        </div>

        <div
          // className="rbt-event-area rbt-section-gap bg-gradient-3"
          id="upcoming-events"
        >
          <EventSection />
        </div>

        <div
          className="rbt-course-area bg-color-extra2 rbt-section-gap"
          id="top-courses"
        >
          <CourseSection />
        </div>
        <div
          className="rbt-course-area bg-color-extra2 rbt-section-gap"
          id="top-jobs"
        >
          <div className="container">
            <div className="row mb--10 mt--20">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  <span className="subtitle bg-secondary-opacity">
                    Explore Jobs
                  </span>
                  <h2 className="title">
                    Top Openings
                    <br />
                    That Everyone&apos;s Talking About 🔥
                  </h2>
                </div>
              </div>
            </div>
            <div className="row mt--80">
              <JobCarousel />
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="load-more-btn mt--30 text-center">
                  <Link
                    href="/jobs"
                    className="rbt-btn btn-gradient btn-lg hover-icon-reverse"
                  >
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">Load More Jobs</span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rbt-about-area bg-color-white rbt-section-gapTop pb_md--80 pb_sm--80 about-style-1">
          <div className="container">
            <AboutUs />
          </div>
        </div>

        {/* <div className="rbt-callto-action-area mt_dec--half">
          <CallToAction />
        </div> */}
        <div className="rbt-callto-action-area mt_dec--half">
          <DocumentationSection />
        </div>

        <div className="rbt-counterup-area bg-color-extra2 rbt-section-gapBottom default-callto-action-overlap">
          <div className="container">
            <Counter isDesc={false} />
          </div>
        </div>

        <div className="rbt-team-area bg-color-white rbt-section-gap">
          <TrainerSection />
        </div>

        <div className="rbt-newsletter-area newsletter-style-2 bg-color-primary rbt-section-gap">
          <NewsletterTwo />
        </div>
      </main>
      <ProfileIncompleteModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default MainDemo;
